import React from "react";
import PropTypes from "prop-types";
import dayjs from "dayjs";
import NotificationWarningIcon from "../../../Assets/IconComponents/NotificationWarningIcon";
import NotificationInfoIcon from "../../../Assets/IconComponents/NotificationInfoIcon";
import { useFeatureFlagEnabled } from "posthog-js/react";

const UnderpaymentSummaryItem = ({ summary, onOpen }) => {
  const formattedTotal = summary.totalBackPayment.toLocaleString("en-US", { style: "currency", currency: "USD" });
  return (
    <div className="dashboard-feed-list-item">
      <div className="dashboard-feed-list-item-icon">
        <NotificationWarningIcon />
      </div>
      <div className="dashboard-feed-list-item-detail" onClick={onOpen}>
        <div className="detail-title">
          Prevailing Wage Underpayments — {summary.recordCount.toLocaleString()}
        </div>
        <div className="detail-date">
          {formattedTotal} back payment · {summary.projectCount} projects · {summary.payPeriodCount} pay periods
        </div>
        <div className="detail-date" style={{ color: "#1565C0", fontWeight: "bold", cursor: "pointer" }}>View all underpayments →</div>
      </div>
    </div>
  );
};

const FeedListItemIcon = ({ eventCategoryTypeId }) => {
  if ([3, 4, 5].includes(eventCategoryTypeId)) {
    return <NotificationInfoIcon />;
  }

  return <NotificationWarningIcon />;
};

const FeedListItem = ({ info, handleOpen, setFeedData }) => {
  const { eventDescription, eventCategoryTypeId, createdDate } = info;
  const openProjectFeed = () => {
    if ([2, 6, 8, 9, 10, 11, 12, 13].includes(eventCategoryTypeId)) {
      setFeedData(info);
      handleOpen();
    }
  };
  return (
    <div className="dashboard-feed-list-item">
      <div className="dashboard-feed-list-item-icon">
        <FeedListItemIcon eventCategoryTypeId={eventCategoryTypeId} />
      </div>
      <div className="dashboard-feed-list-item-detail" onClick={openProjectFeed}>
        <div className="detail-title">{eventDescription}</div>
        <div className="detail-date">{dayjs(createdDate).format("MM/DD/YYYY")}</div>
      </div>
    </div>
  );
};

FeedListItem.propTypes = {
  info: PropTypes.shape({
    title: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired
  }).isRequired
};

export default function FeedList({ feedJson, underpaymentSummary, handleOpen, setFeedData, onOpenUnderpaymentPreview }) {
  const isDetailedUnderpaymentFeedEnabled = useFeatureFlagEnabled("EnableDetailedUnderPaymentFeedDetails");
  const showUnderpaymentSummary = isDetailedUnderpaymentFeedEnabled && underpaymentSummary && underpaymentSummary.recordCount > 0;

  return (
    <div className="dashboard-feed-list">
      {showUnderpaymentSummary && <UnderpaymentSummaryItem summary={underpaymentSummary} onOpen={onOpenUnderpaymentPreview} />}
      {feedJson?.map((feed, index) => (
        <FeedListItem key={Number(index)} info={feed} handleOpen={handleOpen} setFeedData={setFeedData} />
      ))}
    </div>
  );
}

FeedList.propTypes = {
  feedJson: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired
    })
  ).isRequired
};
